<template lang="pug">
  .default-pdp-best-match
    a.find-your-shade-link.upper(v-if="showMissingAdvisor" :href="advisorUrl" @click.prevent="trackMREventAndRedirect('DefaultPdpBestMatch - Find My Perfect Shade Clicked', advisorUrl)")
      mr-icon.xs-hide.md-hide(name="color-circle" height="1.5em" :original="true")
      span.semi-bold.xs-f-xsmall.md-f-small Find My Perfect Shade
      mr-icon.shade-icon(name="arrow-right" height="0.8em" :fill="true")

    p.pdp-best-match.text-color-3.xs-f-small.lg-f-medium.max-at-tweak(v-if="colorKitName")
      span.best-icon.cta-color-4
        mr-icon(name="heart" style="width: 1em;")
      span Best match with&nbsp;
      span.product-name.brand-color-1 {{ colorKitName }}
      span  hair color

    p.pdp-best-match.text-color-3.text-left.text-color-1.xs-f-small.lg-f-medium.max-at-tweak(v-if="showBestMatch")
      span.best-icon.cta-color-4
        mr-icon(name="heart" style="width: 1em;")
      span Your best match is&nbsp;
      span.product-name.brand-color-1 {{ bestMatchName }}


</template>

<script>
  import { mapState, mapGetters } from "vuex";
  import MrIcon from '@components/MrIcon/MrIcon';

  export default {
    name: "DefaultPdpBestMatch",

    components: {
      MrIcon,
    },

    data() {
      return {
        rectypeMap: {
          'color_kit': 'color',
          'colorwonder': 'color',
          'light_works': 'lw',
          'root_touch_up': 'rtu',
          'root_reboot': 'rrb',
          'root_perfection': 'rp',
        },
        bestMatchProductTypes: {
          'color_kit': true,
          'colorwonder': true,
          'light_works': true,
          'root_perfection': true,
        }
      };
    },

    computed: {
      ...mapState('pdp', ['product']),
      ...mapState('colorAdvisor', ['advisorCompleted', 'lightWorksQuizCompleted']),
      ...mapState('xsell', ['xsellForActiveColorKitSubs']),
      ...mapGetters('customer', ['bestMatchesByProductTypeMap']),

      rectype() {
        return this.rectypeMap[this.product.product_type] || null;
      },

      showMissingAdvisor() {
        if (this.rectype == 'lw') {
          return !this.lightWorksQuizCompleted;
        } else {
          return !this.advisorCompleted && (this.product.product_type == 'root_perfection' || this.product.product_type == 'colorwonder');
        }
      },

      advisorUrl() {
        return `/color-advisor${ this.rectype ? '?rectype=' + this.rectype : '' }`;
      },

      bestMatch() {
        if (this.product && this.bestMatchesByProductTypeMap) {
          return this.bestMatchesByProductTypeMap[this.product.product_type];
        }
        return null;
      },

      bestMatchName() {
        return this.bestMatch?.name;
      },

      isBestMatch() {
        return this.bestMatch && this.product.id == this.bestMatch.id;
      },

      showBestMatch() {
        return !this.showMissingAdvisor && this.isBestMatch && this.bestMatchProductTypes[this.product.product_type];
      },

      colorKitName() {
        if (!this.xsellForActiveColorKitSubs || !this.xsellForActiveColorKitSubs.length) {
          return null;
        }

        var subXsellWithProductInXsell = this.xsellForActiveColorKitSubs.find(subXsell => {
          if (!subXsell.xsell || !subXsell.xsell.length) {
            return false;
          }

          return subXsell.xsell.some(prod => prod.code == this.product.code);
        });

        if (subXsellWithProductInXsell) {
          return subXsellWithProductInXsell.subscription.productName;
        } else {
          return null;
        }
      }
    }
  };
</script>

<style scoped lang="stylus">
  .default-pdp-best-match
    .find-your-shade-link
      margin 0.5em 0
      border-top 2px solid #7E727E33
      border-bottom 2px solid #7E727E33
      color brand-color-1
      letter-spacing 0.015rem
      padding 0.8em 0.5em 0.8em 0
      width 100%
      display flex
      justify-content space-between
      align-items center
      transition background-color 0.2s ease-in-out

      &:hover
        cursor pointer
        background-color #7E727E33

      &:active
        background-color #eaeaea

      @media mq-desktop-plus
        border 2px solid #7E727E33
        justify-content center
        gap 1em

      .shade-icon
        @media mq-desktop-plus
          margin-left 0.5em

      .palette-icon-wrap
        width 1.5em
        margin-left 1.9em
        
    .pdp-best-match
      position relative
      margin 0.75em 0
      padding 0.75em 1.5em
      padding-left 3em
      background-color #F2EFF5
      
      .best-icon
        position absolute
        top 0.75em
        left 1.5em
      
</style>
